import { useSession } from "next-auth/react"

export type UserInfo = {
  email: string
  name: string
  firstName?: string
  lastName?: string
  picture: string
}

export function useUserInfo(): UserInfo | null {
  const { data: session } = useSession()

  if (
    !session ||
    !session.user ||
    !session.user.email ||
    !session.user.name ||
    !session.user.image
  ) {
    return null
  }

  const fullName = session.user.name.trim()
  const parts = fullName.split(/\s+/).filter(Boolean)
  const firstName = parts[0] || fullName
  const lastName = parts.length > 1 ? parts.slice(1).join(" ") : ""

  return {
    email: session.user.email,
    name: fullName,
    firstName,
    lastName,
    picture: session.user.image,
  }
}
